/**
 * @generated SignedSource<<f9b19a224bc12f043fc6bb763d04300a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addProfanityRulePanel_ProfanityFilterRulesListQuery$variables = Record<PropertyKey, never>;
export type addProfanityRulePanel_ProfanityFilterRulesListQuery$data = {
  readonly profanityFilterRules: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly printTypes: ReadonlyArray<{
        readonly printTypeID: number;
      } | null> | null;
    } | null> | null;
  } | null;
};
export type addProfanityRulePanel_ProfanityFilterRulesListQuery = {
  response: addProfanityRulePanel_ProfanityFilterRulesListQuery$data;
  variables: addProfanityRulePanel_ProfanityFilterRulesListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 200
      }
    ],
    "concreteType": "ProfanityFilterRulesConnection",
    "kind": "LinkedField",
    "name": "profanityFilterRules",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfanityFilterRule",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfanityFilterRulePrintType",
            "kind": "LinkedField",
            "name": "printTypes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "printTypeID",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "profanityFilterRules(first:200)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "addProfanityRulePanel_ProfanityFilterRulesListQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "addProfanityRulePanel_ProfanityFilterRulesListQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "09aebb2d730a32c5929688286ab2579e",
    "id": null,
    "metadata": {},
    "name": "addProfanityRulePanel_ProfanityFilterRulesListQuery",
    "operationKind": "query",
    "text": "query addProfanityRulePanel_ProfanityFilterRulesListQuery {\n  profanityFilterRules(first: 200) {\n    nodes {\n      id\n      name\n      printTypes {\n        printTypeID\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8ce7b10cf5f349a266bd32f49c879c18";

export default node;
